import { render, staticRenderFns } from "./WaiterChangeRequest.vue?vue&type=template&id=5bc29090&scoped=true&lang=pug"
import script from "./WaiterChangeRequest.vue?vue&type=script&lang=ts"
export * from "./WaiterChangeRequest.vue?vue&type=script&lang=ts"
import style0 from "./WaiterChangeRequest.vue?vue&type=style&index=0&id=5bc29090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc29090",
  null
  
)

export default component.exports